<template>
    <div>
        <transition name="modal-fade">
            <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
                <div class="modal-container">
                    <div class="modal-content">
                        <div class="header">
                            <p>
                                {{ modalData.title }}
                            </p>
                            <button class="close-button" @click="closeModal">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                </svg>
                            </button>
                        </div>


                        <div v-if="modalData && modalData.resource && modalData.resource.typeFormId">
                            <TypeformEmbed :typeFormId="modalData.resource.typeFormId" />
                        </div>

                        <div v-else class="empty-state">
                            <p>No hay datos de interacción disponibles</p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import TypeformEmbed from './TypeformEmbed.vue';

export default {
    name: "CenteredModal",
    components: {
        TypeformEmbed
    },
    props: {
        modalData: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            isModalOpen: false
        };
    },
        beforeDestroy() {
        document.body.style.overflow = "";
    },
    methods: {
        openModal(data) {
            console.log('🎯 Modal abierto con data:', data);
            this.isModalOpen = true;
            document.body.style.overflow = "hidden";

            if (data) {
                this.$emit('modal-opened', data);
            }
        },
        closeModal() {
            this.isModalOpen = false;
            document.body.style.overflow = "";
            this.$emit('modal-closed');
        }
    },
};
</script>

<style scoped>
/* Overlay del modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

/* Container con padding del 20% */
.modal-container {
    width: 100%;
    height: 100%;
    padding: 3dvh 5vw;
    display: flex;
}

/* Contenido del modal */
.modal-content {
    background: white;
    border-radius: 12px;
    padding: 32px;
    max-width: 100%;
    max-height: 100%;
    overflow-y: auto;
    position: relative;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    width: 100%;
}

/* Botón de cerrar */
.close-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 6px;
    transition: background-color 0.2s;
    color: #6b7280;
}

.close-button:hover {
    background-color: #f3f4f6;
    color: #111827;
}

/* Título */
.modal-title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 16px;
    color: #111827;
    padding-right: 40px;
}

/* Cuerpo del modal */
.modal-body {
    margin-bottom: 24px;
    color: #374151;
}

.modal-description {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 16px;
}

.custom-content {
    padding: 16px;
    background-color: #f9fafb;
    border-radius: 8px;
    margin-bottom: 16px;
}

.additional-info {
    background-color: #f3f4f6;
    padding: 12px;
    border-radius: 6px;
    font-family: monospace;
    font-size: 12px;
    overflow-x: auto;
}

.additional-info pre {
    margin: 0;
    white-space: pre-wrap;
}

/* Estado vacío */
.empty-state {
    text-align: center;
    padding: 40px;
    color: #9ca3af;
}

/* Footer con botones */
.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #e5e7eb;
}

.btn-secondary,
.btn-primary {
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
}

.btn-secondary {
    background-color: #f3f4f6;
    color: #374151;
}

.btn-secondary:hover {
    background-color: #e5e7eb;
}

.btn-primary {
    background-color: #272727;
    color: white;
}

.btn-primary:hover {
    background-color: #000000;
}

/* Animaciones */
.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.3s ease;
}

.modal-fade-enter-active .modal-content,
.modal-fade-leave-active .modal-content {
    transition: transform 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter .modal-content,
.modal-fade-leave-to .modal-content {
    transform: scale(0.9);
}

.header {
    display: flex;
    margin-bottom: 2dvh;
    justify-content: space-between;
    align-items: center;

    color:#000000;
    font-weight: 600;
    cursor: pointer;
}

/* Responsive */
@media (max-width: 768px) {
    .modal-container {
        padding: 3dvh 5vw;
    }

    .modal-title {
        font-size: 20px;
    }

    .modal-footer {
        flex-direction: column;
    }

    .btn-secondary,
    .btn-primary {
        width: 100%;
    }
}
</style>